/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown>, count: NonNullable<unknown> }} Pricing_Yearly_BilledInputs */

const tr_pricing_yearly_billed = /** @type {(inputs: Pricing_Yearly_BilledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yıllık ${i?.price} ₺ (${i?.count} ay ücretsiz)`)
};

const en_pricing_yearly_billed = /** @type {(inputs: Pricing_Yearly_BilledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yearly ${i?.price} ₺ (${i?.count} months free)`)
};

const de_pricing_yearly_billed = /** @type {(inputs: Pricing_Yearly_BilledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jährlich ${i?.price} ₺ (${i?.count} Monate kostenlos)`)
};

const ru_pricing_yearly_billed = /** @type {(inputs: Pricing_Yearly_BilledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ежегодно ${i?.price} ₺ (${i?.count} месяца бесплатно)`)
};

/**
* | output |
* | --- |
* | "Yearly {price} ₺ ({count} months free)" |
*
* @param {Pricing_Yearly_BilledInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_yearly_billed = /** @type {((inputs: Pricing_Yearly_BilledInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Yearly_BilledInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_yearly_billed(inputs)
	if (locale === "de") return de_pricing_yearly_billed(inputs)
	if (locale === "ru") return ru_pricing_yearly_billed(inputs)
	return tr_pricing_yearly_billed(inputs)
});